// Company subdomain whose Qayd subscription has ended (after the grace period). Data is kept.
import { QaydLogo } from "components/Brand";

export default function SubscriptionEnded({ name }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-4 text-center">
      <div className="max-w-[440px]">
        <div className="flex justify-center">
          <QaydLogo size={32} />
        </div>
        <h1 className="m-0 mt-8 text-[22px] font-semibold tracking-[-0.02em] text-fg">Subscription ended</h1>
        <p className="m-0 mt-2 text-[14px] text-muted">
          <span className="font-medium text-text">{name}</span>'s Qayd subscription has ended, so sign-in is paused. All your
          data is kept and everything comes back as soon as the subscription is renewed.
        </p>
        <p className="m-0 mt-4 text-[13px] text-faint">Please contact your administrator or Qayd support to renew.</p>
      </div>
    </div>
  );
}
